import request from "@/utils/request"

const fetchOwnerOrg = () =>
  request.get("/api/settings/multi_user_plans/organisation", { token: true }).then((response) => response)

const createOwnerOrg = (name) => {
  return request.post("/api/settings/multi_user_plans/organisation", {
    body: {
      name
    },
    token: true
  })
}

const removeMemberFromOrg = (id) => {
  return request.delete(`/api/settings/multi_user_plans/member/${id}`, { token: true })
}

const getUserName = () =>
  request.get("/api/settings/multi_user_plans/user_name", {
    token: true
  })

const changeName = (name) =>
  request.put("/api/settings/multi_user_plans/user_name", {
    body: {
      name
    },
    token: true
  })

export default {
  createOwnerOrg,
  fetchOwnerOrg,
  removeMemberFromOrg,
  getUserName,
  changeName
}
